import { fabric } from "fabric";
import { undo, redo } from 'fabric-history';
import { useLayoutEffect, useState } from "react";
import { useContext, useEffect, useRef } from "react";
import { Button, Col, Dropdown, Form, Nav, ProgressBar, Row, Stack } from "react-bootstrap";
import { json, Link, useNavigate, useParams } from "react-router-dom";
import { useEvent, useKey } from "react-use";
import frames from '../data/frames.json';
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFont, faCircle, faImage, faSquare, faCog, faAngleUp, faAngleDoubleUp, faAngleDown, faAngleDoubleDown, faBold, faItalic, faCartArrowDown, faArrowDown, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import useTooltips from "../hooks/useTooltips ";
import { faArrowAltCircleRight, faCopy, faNewspaper, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { ENDPOINT_COMPONENT, ENDPOINT_FRAME_PRESIGNED_UPLOAD } from "../Config";
import usePageTitle from "../hooks/usePageTitle";
import useEventCtx from '../hooks/useEventCtx';

const FrameBuilder = () => {
    const { groupId } = useParams();
    usePageTitle('Setup Video Branding');
    useTooltips();
    const navigate = useNavigate();
    const { auth, setAuth } = useAuth();
    const { event, setEvent } = useEventCtx();
    const axiosPrivate = useAxiosPrivate();
    const containerEl = useRef(null);
    const canvasWidth = 1920;
    const canvasHeight = 1080;
    const [containerWidth, setContainerWidth] = useState(600);
    const VIDEO_OBJECT_ID = "VIDEO";
    const BACKGROUND_OBJECT_ID = "BACKGROUND";
    const LOGO_OBJECT_ID = "LOGO";
    const BANNER_OBJECT_ID = "BANNER";
    const CONTEXT_MENU_ID = "contextMenu";
    const [isLoading, setIsLoading] = useState(false);
    const [canvas, setCanvas] = useState(null);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [frameJsonUrl, setFrameJsonUrl] = useState(null);
    const [videoPlaceholder, setVideoPlaceholder] = useState(null);
    const [backgroundPlaceholder, setBackgroundPlaceholder] = useState(null);
    const [logoPlaceholder, setLogoPlaceholder] = useState(null);
    const [bannerPlaceholder, setBannerPlaceholder] = useState(null);
    const [crawlUrl, setCrawlUrl] = useState("");
    const [crawlLoading, setCrawlLoading] = useState(false);
    const [crawlResult, setCrawlResult] = useState(null);
    const [uploadPercentage, setUploadPercentage] = useState(-1);
    const [color, setColor] = useState('#000000');
    const [fontBold, setFontBold] = useState(false);
    const [fontItalic, setFontItalic] = useState(false);
    const [selectedObject, setSelectedObject] = useState(null);
    const fontFamilyRef = useRef();
    const fontSizeRef = useRef();
    // let videoPlaceholder = null;

    const onAddCircle = () => {
        // editor.addCircle();
        var circle = new fabric.Circle({
            radius: 100, fill: color, left: 100, top: 100
        });
        canvas.add(circle);
        // setEditorCTX(JSON.stringify(editor.canvas));
    };
    const onAddRectangle = () => {
        // editor.addRectangle();
        var rect = new fabric.Rect({
            left: 150,
            top: 150,
            fill: color,
            width: 100,
            height: 100
        });

        canvas.add(rect);
    };
    const onAddText = () => {
        // editor.addText("Text");
        const text = "Sample text";
        const object = new fabric.Textbox(text, {
            type: 'text',
            left: 50,
            fill: color,
            top: 50,
            fontSize: 100,
            width: 580,
            fontFamily: 'Arial'
        })
        object.set({ text: text });
        object.setControlsVisibility({
            mt: false, // middle top disable
            mb: false, // middle bottom
        });
        canvas.add(object);
    };

    const addImage = (inputEvent, callback) => {
        var reader = new FileReader();
        reader.onload = function (event) {
            var img = new Image();
            img.onload = function () {
                fabric.Image.fromObject(img, (img) => {
                    callback(img);
                });
            }
            img.src = event.target.result;
        }
        reader.readAsDataURL(inputEvent.target.files[0]);
        inputEvent.target.value = null;
    }

    // const onAddBackground = (e) => {
    //     addImage(e.target.files[0], (img) => {
    //         canvas.setBackgroundImage(img);
    //         canvas.renderAll();
    //     });
    // };

    const handleImageChange = (img, canvasObj) => {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = function (e) {
            addImage(e, (newImg) => {
                var left = img.left;
                var top = img.top;
                var width = img.width;
                var height = img.height;

                var aspectRatio = newImg.width / newImg.height;
                var maxWidth, maxHeight;
                if (aspectRatio >= 1) {
                    maxWidth = width;
                    maxHeight = width / aspectRatio;
                } else {
                    maxHeight = height;
                    maxWidth = height * aspectRatio;
                }
                // Scale the new image to fit the maximum width or height of the original image
                var scale = Math.min(maxWidth / newImg.width, maxHeight / newImg.height);
                newImg.scale(scale);
                // Set the new image's position and size to match the original image
                newImg.set({
                    left: left + (width - newImg.getScaledWidth()) / 2,
                    top: top + (height - newImg.getScaledHeight()) / 2
                });
                var originalIndex = canvasObj.getObjects().indexOf(img);
                canvasObj.remove(img);
                canvasObj.add(newImg);
                newImg.moveTo(originalIndex);
                canvasObj.renderAll();
                // canvas.historyNextState = canvas._historyNext();
            });
        };
        input.click();
    }

    const onUploadImage = (e) => {
        addImage(e, (img) => {
            canvas.add(img);
            canvas.renderAll();
        });
    };

    const removeObjectFromCanvas = () => {
        const obj = canvas.getActiveObject();
        if (obj?.id === VIDEO_OBJECT_ID || obj?.isEditing) {
            return;
        }
        canvas.remove(canvas.getActiveObject());
    };
    const moveObject = (x, y) => {
        const obj = canvas.getActiveObject();
        if (obj) {
            obj.set({
                'top': obj.top + y,
                'left': obj.left + x
            });
        }
        canvas.fire('object:moving', { target: obj }); // to make sure that the video placeholder don't go out of canvas boundaries
        canvas.fire('object:modified', { target: obj }); // to handle context menu
        canvas.renderAll();
    };

    // const downloadImage = () => {
    //     const ext = "png";
    //     const base64 = canvas.toDataURL({
    //         format: ext,
    //         enableRetinaScaling: true
    //     });
    //     const link = document.createElement("a");
    //     link.href = base64;
    //     link.download = `frame.${ext}`;
    //     link.click();
    // };
    useKey('Delete', removeObjectFromCanvas, { event: 'keyup' }, [canvas]);
    useKey('ArrowUp', (e) => {
        e.preventDefault();
        moveObject(0, -1)
    }, { event: 'keydown' }, [canvas]);
    useKey('ArrowDown', (e) => {
        e.preventDefault();
        moveObject(0, 1)
    }, { event: 'keydown' }, [canvas]);
    useKey('ArrowLeft', (e) => {
        e.preventDefault();
        moveObject(-1, 0)
    }, { event: 'keydown' }, [canvas]);
    useKey('ArrowRight', (e) => {
        e.preventDefault();
        moveObject(1, 0)
    }, { event: 'keydown' }, [canvas]);
    useEvent('keydown', (event) => {
        if (event.ctrlKey && event.key === 'z') {
            event.preventDefault();
            canvas.undo();
        } else if (event.ctrlKey && event.key === 'y') {
            event.preventDefault();
            canvas.redo();
        }
    });

    const handleTemplateChange = () => {
        canvas.setBackgroundColor(selectedTemplate.backgroundColor);
        setColor(selectedTemplate.fillColor);
        let videoObj = videoPlaceholder;
        if (!videoObj) {
            videoObj = new fabric.Rect({
                id: VIDEO_OBJECT_ID,
                left: selectedTemplate.video.x,
                top: selectedTemplate.video.y,
                width: selectedTemplate.video.w,
                height: selectedTemplate.video.h,
                fill: 'black'
            });
            fabric.util.loadImage('/assets/images/video-box.svg', function (img) {
                videoObj.set(
                    'fill', new fabric.Pattern({
                        source: img,
                        repeat: 'no-repeat',
                        patternTransform: [videoObj.width / img.width, 0, 0, videoObj.height / img.height, (videoObj.width - img.width * (videoObj.width / img.width)) / 2, (videoObj.height - img.height * (videoObj.height / img.height)) / 2]
                    })
                );
                canvas.renderAll();
            });
            canvas.add(videoObj);
            setVideoPlaceholder(videoObj);
        }
        canvas.renderAll();
    };

    const handleContextMenu = (obj) => {
        var contextMenu = document.getElementById(CONTEXT_MENU_ID);
        var contextDropMenu = document.querySelector('#contextDropMenu');
        var changeImageMenuItem = document.querySelector('#liChangeImage');
        contextDropMenu.classList.remove('show');
        changeImageMenuItem.classList.add('d-none');
        if (!obj || obj.id === VIDEO_OBJECT_ID) {
            contextMenu.classList.add("d-none");
            return;
        }
        var viewportTransform = obj.canvas.viewportTransform;

        // get top/left position of object on scaled canvas
        var scaledLeft = (obj.left - viewportTransform[4]) / viewportTransform[0];
        var scaledTop = (obj.top - viewportTransform[5]) / viewportTransform[3];

        //console.log('Object is at coordinates:', scaledLeft, scaledTop);
        contextMenu.classList.remove("d-none");
        contextMenu.style.left = Math.min(obj.canvas.width - 50, Math.max(0, scaledLeft)) + 'px';
        contextMenu.style.top = Math.min(obj.canvas.height - 50, Math.max(0, scaledTop - 50)) + 'px';


        if (obj.type === 'image') {
            changeImageMenuItem.classList.remove('d-none');
        }
    };

    const setTextProp = (prop) => {
        var activeObj = canvas.getActiveObject();
        if (activeObj) {
            activeObj.set(prop);
            canvas.renderAll();
        }
    }

    useEffect(() => {
        const loadFrame = async () => {
            setIsLoading(true);
            try {
                const frameJSON = await axios.get(frameJsonUrl);
                frameJSON.data.objects.forEach(item => {
                    if (item.type === 'text') {
                        item.type = 'i-text';
                    }
                });
                canvas.loadFromJSON(frameJSON.data, function () {
                    setVideoPlaceholder(canvas.getObjects().find(item => item.id === VIDEO_OBJECT_ID));
                    setBackgroundPlaceholder(canvas.getObjects().find(item => item.id === BACKGROUND_OBJECT_ID));
                    setLogoPlaceholder(canvas.getObjects().find(item => item.id === LOGO_OBJECT_ID));
                    setBannerPlaceholder(canvas.getObjects().find(item => item.id === BANNER_OBJECT_ID));
                    canvas.getObjects().filter(item => item.type === 'i-text').forEach(function (obj) {
                        obj.setControlsVisibility({
                            mt: false, // middle top disable
                            mb: false, // middle bottom
                            mr: false, // middle right
                            ml: false, // middle left
                        });
                    })
                    // setEditorCTX((prev) => ({
                    //     ...prev,
                    //     canvas: JSON.stringify(frameJSON.data)
                    // }));
                    canvas.clearHistory();
                    canvas.historyNextState = canvas._historyNext();
                });
            } catch (error) {

            } finally {
                setIsLoading(false);
            }
        }
        loadFrame()
    }, [frameJsonUrl]);

    useEffect(() => {
        handleContextMenu(selectedObject);
        if (selectedObject !== null && (selectedObject.type === 'text' || selectedObject.type === 'i-text')) {
            fontFamilyRef.current.value = selectedObject.get('fontFamily');
            fontSizeRef.current.value = selectedObject.get('fontSize');
            setFontBold(selectedObject.get('fontWeight') === 'bold');
            setFontItalic(selectedObject.get('fontStyle') === 'italic');
        }
    }, [selectedObject]);

    useEffect(() => {
        if (!selectedObject || selectedObject.id === VIDEO_OBJECT_ID || selectedObject.type === 'image') {
            return;
        }
        var activeObj = canvas.getActiveObject();
        if (activeObj) {
            activeObj.set('fill', color);
            canvas.renderAll();
        }
    }, [color]);

    useEffect(() => {
        //console.log('selectedTemplate', selectedTemplate, editor);
        if (!videoPlaceholder)
            return;
        videoPlaceholder.set({
            lockRotation: true,
            lockScalingFlip: true,
            minScaleLimit: 0.5,
        });
        videoPlaceholder.setControlsVisibility({
            mt: false,
            mb: false,
            mr: false,
            ml: false,
            mtr: false
        });
        canvas.off('object:added').on('object:added', function (e) {
            var videoObj = canvas.getObjects().find(item => item.id === VIDEO_OBJECT_ID);
            videoObj?.bringToFront();
        });
    }, [videoPlaceholder]);

    useEffect(() => {
        if (!selectedTemplate || !canvas)
            return;
        // handleTemplateChange();
        canvas.setBackgroundColor(selectedTemplate.backgroundColor);
        setColor(selectedTemplate.fillColor);
        // setEditorCTX((prev) => ({
        //     ...prev,
        //     template: selectedTemplate
        // }));
    }, [selectedTemplate]);

    useEffect(() => {
        const canvasObj = new fabric.Canvas('canvas', {
            height: canvasHeight,
            width: canvasWidth,
            preserveObjectStacking: true,
        });
        canvasObj.extraProps = ['selectable', 'editable', 'id'];
        const originalToObject = fabric.Object.prototype.toObject;
        const myAdditionalProperties = ['id'];
        fabric.Object.prototype.toObject = function (additionalProperties) {
            return originalToObject.call(this, myAdditionalProperties.concat(additionalProperties));
        };

        // canvasObj.on('history:append', function (data) {
        //     console.log('data :>> ', JSON.parse(data.json));
        // });


        canvasObj.requestRenderAll();
        setCanvas(canvasObj)

        const loadFrameSettings = async () => {
            setIsLoading(true);
            try {
                if (event?.frameTemplateJson) {
                    setFrameJsonUrl(event.frameTemplateJson);
                } else {
                    // load canvas with first template
                    setSelectedTemplate(frames[0]);
                    setFrameJsonUrl(frames[0].json);
                }
            } catch (error) {
                // setSelectedTemplate(frames[0]);
            } finally {
                setIsLoading(false);
            }
        }
        loadFrameSettings();


        canvasObj.on('object:moving', function (e) {
            var obj = e.target;
            document.getElementById(CONTEXT_MENU_ID).classList.add("d-none");
            if (obj?.id !== VIDEO_OBJECT_ID) {
                return;
            }
            var objWidth = obj.width * obj.scaleX;
            var objHeight = obj.height * obj.scaleX;
            if (obj.left < 0) {
                obj.left = 0;
            }
            if (obj.top < 0) {
                obj.top = 0;
            }
            if (obj.left + objWidth > canvasObj.width) {
                obj.left = canvasObj.width - objWidth;
            }
            if (obj.top + objHeight > canvasObj.height) {
                obj.top = canvasObj.height - objHeight;
            }
        });
        canvasObj.on('object:scaling', function (e) {
            var obj = e.target;
            document.getElementById(CONTEXT_MENU_ID).classList.add("d-none");
            if (obj?.id !== VIDEO_OBJECT_ID) {
                return;
            }
            var boundingRect = obj.getBoundingRect();
            if (boundingRect.left < 0) {
                obj.left = obj.left - boundingRect.left;
            }
            if (boundingRect.top < 0) {
                obj.top = obj.top - boundingRect.top;
            }
            if (boundingRect.left + boundingRect.width > canvasObj.width) {
                obj.left = obj.left - (boundingRect.left + boundingRect.width - canvasObj.width);
            }
            if (boundingRect.top + boundingRect.height > canvasObj.height) {
                obj.top = obj.top - (boundingRect.top + boundingRect.height - canvasObj.height);
            }
            var maxScale = canvasObj.width / obj.width;  // set your max scale size here
            if (obj.scaleX > maxScale) {
                obj.scaleX = maxScale;
                obj.scaleY = maxScale;
            }
        });
        ["selection:created", "selection:updated"].forEach(ev => {
            canvasObj.on(ev, function (event) {
                var selectedObject = event.selected[0];
                setSelectedObject(selectedObject);
            });
        });
        canvasObj.on('selection:cleared', function (event) {
            setSelectedObject(null);
        });
        canvasObj.on('object:modified', function (event) {
            handleContextMenu(event.target);
        });
        canvasObj.on('mouse:dblclick', function (event) {
            if (event?.target?.type === 'image') {
                handleImageChange(event.target, canvasObj);
            }
        });
        setContainerWidth(containerEl.current.clientWidth);
    }, [])

    const handleCrawler = async (e) => {
        try {
            setCrawlLoading(true);
            var url = crawlUrl;
            if (!url.startsWith('https://') && url !== '') {
                url = 'https://' + crawlUrl;
                setCrawlUrl(url);
            }
            const response = await axios.get('https://url-fetcher.gv-one.com/load-data-from-url?url=' + url);
            console.log('response :>> ', response);
            const result = response.data;
            if (result?.listOfImages.length > 0) {
                result.listOfImages = result.listOfImages.map(src => ({ src: src }))
            }
            setCrawlResult(result);
        } catch (error) {
            console.log('error :>> ', error);
        } finally {
            setCrawlLoading(false);
        }
    }

    const saveFrame = async () => {
        try {
            setUploadPercentage(0);
            const response = await axiosPrivate.get(ENDPOINT_FRAME_PRESIGNED_UPLOAD.replace('{groupId}', groupId), {
            });
            //console.log(response.data);
            const pngPath = response.data.frameTemplatePNG;
            const jsonPath = response.data.frameTemplateJSON;

            // JSON file
            const jsonBlob = new Blob([JSON.stringify(canvas)]);
            const jsonFile = {
                type: 'JSON',
                path: jsonPath,
                blob: jsonBlob,
                loaded: 0
            }
            // PNG file
            const pngBlob = await fetch(canvas.toDataURL()).then((response) => response.blob());
            const pngFile = {
                type: 'PNG',
                path: pngPath,
                blob: pngBlob,
                loaded: 0
            }
            const files = [jsonFile, pngFile];
            //console.log('Files', files);
            // Calculate total bytes for progress calculation
            let totalBytes = files.reduce((acc, file) => acc + file.blob.size, 0);
            files.map(async (file) => {
                const response = await axios.put(file.path, file.blob, {
                    onUploadProgress: (progressEvent) => {
                        file.loaded = progressEvent.loaded;
                        let totalLoaded = files.reduce((acc, file) => acc + file.loaded, 0);
                        const percentage = Math.round((totalLoaded / totalBytes) * 100);
                        setUploadPercentage(percentage);
                    }
                });
                file.status = response.status;
                let completedCount = files.filter(f => f.status === 200).length;
                console.log('completedCount', completedCount);
                if (completedCount === files.length) {
                    const videoObj = canvas.getObjects().find(item => item.id === VIDEO_OBJECT_ID);
                    //console.log('x', videoObj.left, 'y', videoObj.top, 'w', videoObj.getScaledWidth(), 'h', videoObj.getScaledHeight());
                    const eventResponse = await axiosPrivate({
                        method: event?.frameConfigured ? 'put' : 'post',
                        url: ENDPOINT_COMPONENT.replace('{groupId}', groupId),
                        data: {
                            "videoX": videoObj.left,
                            "videoY": videoObj.top,
                            "videoW": videoObj.getScaledWidth(),
                            "videoH": videoObj.getScaledHeight(),
                            "textX": 667,
                            "textY": 554,
                            "textColor": selectedTemplate?.textColor ? selectedTemplate.textColor : null
                        }
                    },);
                    setEvent((prev) => ({
                        ...prev,
                        frameConfigured: eventResponse.data.frameConfigured,
                        frameTemplateJson: eventResponse.data.frameTemplateJson
                    }));
                    console.log('UPLOAD COMPLETED!', eventResponse);
                    navigate(`/group/${groupId}/invite`);
                }
                // console.log(response.status);
            });
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <div className="App">
            <Row>
                <Col sm={4}>
                    <Dropdown className="mb-3">
                        <Dropdown.Toggle variant="outline-primary" size="lg" id="dropdown-basic" className="w-100 text-black">
                            <strong>
                                <FontAwesomeIcon icon={faNewspaper} fixedWidth /> Select Template
                            </strong>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100 row row-cols-2 overflow-auto" style={{ minHeight: '300px' }}>
                            {
                                frames.map((frame) => (
                                    <Dropdown.Item key={frame.id}
                                        className="col d-inline-block p-3"
                                        bsPrefix=""
                                        style={{ width: '50%' }}
                                        active={selectedTemplate?.id === frame.id}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (selectedTemplate !== frame && videoPlaceholder) {
                                                //canvas.remove(videoPlaceholder);
                                                canvas.clear();
                                                setVideoPlaceholder(null);
                                            }
                                            setSelectedTemplate(frame);
                                            setFrameJsonUrl(frame.json);
                                        }}>
                                        <span className="ratio ratio-16x9">
                                            <img src={frame.thumbnail} alt={frame.name} className="img-fluid img-thumbnail w-100" />
                                        </span>
                                    </Dropdown.Item>
                                ))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="row row-cols-3 g-2 mb-3">
                        <div className="col d-none">
                            <div className="card shadow-sm">
                                <div className="p-2 text-center d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faCircle} fixedWidth size="2x" className="text-primary" />
                                    <button className="stretched-link btn btn-link text-decoration-none text-dark" onClick={onAddCircle}><strong>Add Circle</strong></button>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm">
                                <div className="p-2 text-center d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faSquare} fixedWidth size="2x" className="text-primary" />
                                    <button className="stretched-link btn btn-link text-decoration-none text-dark text-nowrap" onClick={onAddRectangle}><strong>Add Rectangle</strong></button>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm">
                                <div className="p-2 text-center d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faFont} fixedWidth size="2x" className="text-primary" />
                                    <button className="stretched-link btn btn-link text-decoration-none text-dark" onClick={onAddText}><strong>Add Text</strong></button>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm">
                                <div className="p-2 text-center d-flex flex-column align-items-center">
                                    <FontAwesomeIcon icon={faImage} fixedWidth size="2x" className="text-primary" />
                                    <label htmlFor='ImageFile' className="stretched-link btn btn-link text-decoration-none text-dark" style={{ cursor: 'pointer' }}><strong>Add Image</strong></label>
                                    <input id="ImageFile" className="form-control d-none" type="file" accept="image/*" onChange={onUploadImage} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3 bg-light">
                        <div className="card-body">
                            <h6>Import your branding images and colors from your site</h6>
                            <div className="input-group input-group-sm mb-3">
                                <input type="text"
                                    className="form-control"
                                    placeholder="Enter Your URL"
                                    aria-label="Enter Your URL"
                                    onChange={(e) => { setCrawlUrl(e.target.value) }}
                                    value={crawlUrl}
                                    onKeyUp={(e) => {
                                        if (e.key === 'Enter') {
                                            handleCrawler();
                                        }
                                    }} />
                                <button className="btn btn-outline-primary" type="button" onClick={handleCrawler} disabled={crawlLoading || crawlUrl === ''}>
                                    {crawlLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>} Import
                                </button>
                            </div>
                            {
                                crawlResult &&
                                <>
                                    {crawlResult?.mostUsedColors && crawlResult.mostUsedColors.length > 0 &&
                                        <>
                                            <div className="d-flex align-items-center mb-2">
                                                <h6 className="m-0 small">Background Color:&nbsp;</h6>
                                                <div className='hstack gap-1'>
                                                    {
                                                        crawlResult.mostUsedColors.map((color, i) => (
                                                            <div key={`Color${i}`}>
                                                                <label className="btn btn-dark p-0" style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    backgroundColor: color
                                                                }} onClick={(e) => {
                                                                    canvas.setBackgroundColor(color);
                                                                    canvas.renderAll();
                                                                }}
                                                                >
                                                                </label>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-2">
                                                <h6 className="m-0 small">Banner Color:&nbsp;</h6>
                                                <div className='hstack gap-1'>
                                                    {
                                                        crawlResult.mostUsedColors.map((color, i) => (
                                                            <div key={`Color${i}`}>
                                                                <label className="btn btn-dark p-0" style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    backgroundColor: color
                                                                }} onClick={(e) => {
                                                                    if (bannerPlaceholder) {
                                                                        bannerPlaceholder.set('fill', color);
                                                                        canvas.renderAll();
                                                                    }
                                                                }}
                                                                >
                                                                </label>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>

                                        </>
                                    }
                                    {crawlResult?.listOfImages && crawlResult.listOfImages.length > 0 &&
                                        <>
                                            <h6 className="small">Image(s):</h6>
                                            <div className="row g-2">
                                                {
                                                    crawlResult.listOfImages.map((image, i) => (
                                                        <div key={`Image${i}`} className="col-3">
                                                            <div className='ratio ratio-1x1 mb-1'>
                                                                <div className="img-thumbnail d-flex justify-content-center align-items-center h-100 bg-light">
                                                                    <img alt='Sample' src={image.src} className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                </div>
                                                            </div>
                                                            <select className="form-select form-select-sm" onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (val === '')
                                                                    return;
                                                                var obj = selectedObject;
                                                                if (val !== 'Selected') {
                                                                    obj = canvas.getObjects().find(item => item.id === val);
                                                                }
                                                                if (obj) {
                                                                    const setImage = (src) => {
                                                                        var imageCoords = {
                                                                            left: obj.left,
                                                                            top: obj.top,
                                                                            width: obj.width * obj.scaleX,
                                                                            height: obj.height * obj.scaleY
                                                                        };
                                                                        obj.setSrc(src, function () {
                                                                            if (val === LOGO_OBJECT_ID) {
                                                                                setAuth((prev) => ({
                                                                                    ...prev,
                                                                                    logo: src
                                                                                }));
                                                                                obj.set({
                                                                                    left: imageCoords.left + imageCoords.width / 2 - (obj.width * obj.scaleX) / 2,
                                                                                    top: imageCoords.top + imageCoords.height / 2 - (obj.height * obj.scaleY) / 2,
                                                                                    scaleX: obj.scaleX,
                                                                                    scaleY: obj.scaleY
                                                                                });
                                                                            }
                                                                            canvas.renderAll();
                                                                        });
                                                                    }
                                                                    if (!image.base64) {
                                                                        const getBase64Image = async () => {
                                                                            const response = await axios.get('https://m9vhzc4kf2.execute-api.us-east-1.amazonaws.com/prod/base64image?imageUrl=' + encodeURIComponent(image.src));
                                                                            image.base64 = 'data:image/png;base64,' + response.data;
                                                                            setImage(image.base64);
                                                                        };
                                                                        getBase64Image();
                                                                    } else {
                                                                        setImage(image.base64);
                                                                    }
                                                                }
                                                                e.target.selectedIndex = 0;
                                                            }}>
                                                                <option value="">Set As</option>
                                                                <option value={BACKGROUND_OBJECT_ID}>Background</option>
                                                                <option value={LOGO_OBJECT_ID}>Logo</option>
                                                                <option value="Selected" disabled={!selectedObject || selectedObject.id === VIDEO_OBJECT_ID || selectedObject.type !== 'image'}>Selected Item Image</option>
                                                            </select>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                    {
                        selectedObject && selectedObject.id !== VIDEO_OBJECT_ID && selectedObject.type !== 'image' &&
                        <div>
                            <hr />
                            <div className="hstack gap-1">
                                <div>
                                    <div className="input-group input-group-sm flex-nowrap">
                                        <div className="input-group-text">Color</div>

                                        <input type="color" id="color" name="color" className="form-control form-control-sm p-0" value={color} style={{ width: '35px' }}
                                            onChange={(e) => {
                                                setColor(e.target.value);
                                            }} />
                                        {crawlResult && crawlResult?.mostUsedColors && crawlResult.mostUsedColors.length > 0 &&
                                            <span className="input-group-text p-0 bg-white">
                                                <div className="dropdown">
                                                    <button className="btn btn-sm btn-link py-0 px-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <FontAwesomeIcon icon={faChevronDown} size="sm" fixedWidth className="text-dark" />
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-end p-1" style={{ maxWidth: 'none', minWidth: '90px' }}>
                                                        <div className='hstack gap-1 px-1'>
                                                            {
                                                                crawlResult.mostUsedColors.map((color, i) => (
                                                                    <div key={`Color${i}`}>
                                                                        <label className="btn btn-dark p-0" style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            backgroundColor: color
                                                                        }} onClick={(e) => {
                                                                            setColor(color);
                                                                        }}
                                                                        >
                                                                        </label>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        }
                                    </div>
                                </div>
                                {(selectedObject.type === 'text' || selectedObject.type === 'i-text') &&
                                    <div className="flex-grow-1">
                                        <div className="input-group input-group-sm">
                                            <div className="input-group-text">Font</div>
                                            <select id="fontFamily" ref={fontFamilyRef} className="form-select" onChange={(e) => { setTextProp({ fontFamily: e.target.value }) }}>
                                                <option value="Arial">Arial</option>
                                                <option value="Verdana">Verdana</option>
                                                <option value="Times New Roman">Times New Roman</option>
                                            </select>
                                            <div className="input-group-text">Size</div>
                                            <input type="number" id="fontSize" ref={fontSizeRef} className="form-control border-end-0" onChange={(e) => { setTextProp({ fontSize: e.target.value }) }} />
                                            <span className="input-group-text p-0 bg-white border-start-0">
                                                <div className="dropdown">
                                                    <button className="btn btn-sm btn-link ps-0 pe-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <FontAwesomeIcon icon={faChevronDown} size="sm" fixedWidth className="text-dark" />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end overflow-auto" style={{ maxHeight: `250px`, maxWidth: '90px', minWidth: '75px' }}>
                                                        {
                                                            Array.from([20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 32, 34, 36, 38, 40, 44, 48, 54, 60, 70, 80], (i, index) => {
                                                                var value = i;
                                                                return (
                                                                    <li key={index}>
                                                                        <button className="dropdown-item" type="button" id="btnChangeImage" onClick={(e) => {
                                                                            fontSizeRef.current.value = value;
                                                                            setTextProp({ fontSize: value });
                                                                        }}>{value}</button>

                                                                    </li>
                                                                );
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </span>
                                            <div className="input-group-text">Style</div>
                                            <button type="button" className={`btn btn-outline-dark ${fontBold ? 'active' : ''}`} onClick={(e) => {
                                                var toggled = !fontBold;
                                                setFontBold(toggled);
                                                setTextProp({ fontWeight: toggled ? 'bold' : 'normal' });
                                            }}><FontAwesomeIcon icon={faBold} fixedWidth></FontAwesomeIcon></button>
                                            <button type="button" className={`btn btn-outline-dark ${fontItalic ? 'active' : ''}`} onClick={(e) => {
                                                var toggled = !fontItalic;
                                                setFontItalic(toggled);
                                                setTextProp({ fontStyle: toggled ? 'italic' : 'normal' });
                                            }}><FontAwesomeIcon icon={faItalic} fixedWidth></FontAwesomeIcon></button>

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    {false && selectedObject && selectedObject.id !== VIDEO_OBJECT_ID &&
                        <div className="alert alert-info mt-3 p-1" role="alert">
                            <ul className="m-0">
                                <li>
                                    Hit <kbd>Delete</kbd> button from keyboard to remove selected item.{selectedObject.id}
                                </li>
                                {selectedObject?.type === 'image' &&
                                    <li>
                                        <code>Double Click</code> the image to change it.
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </Col>
                <Col sm={8}>
                    <div ref={containerEl} style={{
                        height: containerWidth * canvasHeight / canvasWidth
                    }}>
                        <div className="card rounded-0" style={{
                            width: canvasWidth,
                            position: "absolute",
                            height: canvasHeight,
                            transform: `scale(${containerWidth / canvasWidth})`,
                            transformOrigin: "top left"
                        }}>
                            {/* <FabricJSCanvas className="editor-wrapper" onReady={onCanvasReady} /> */}
                            <canvas id="canvas" />

                            <div id="contextMenu" className="dropdown d-none position-absolute" style={{
                                transform: `scale(${(2 * containerWidth / canvasWidth) + (1 - containerWidth / canvasWidth)})`,
                                transformOrigin: "top left"
                            }}>
                                <button className="btn btn-dark btn-sm" type="button" id="contextMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    <FontAwesomeIcon icon={faCog} fixedWidth />
                                </button>
                                <ul id="contextDropMenu" className="dropdown-menu dropdown-menu-dark">
                                    <li id="liChangeImage">
                                        <button className="dropdown-item" type="button" id="btnChangeImage" onClick={(e) => {
                                            handleImageChange(selectedObject, canvas);
                                        }}>
                                            <FontAwesomeIcon icon={faImage} fixedWidth /> Change
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" type="button" onClick={(e) => {
                                            var clonedObject = fabric.util.object.clone(canvas.getActiveObject());
                                            clonedObject.left += 10;
                                            clonedObject.top += 10;
                                            canvas.add(clonedObject);
                                        }}>
                                            <FontAwesomeIcon icon={faCopy} fixedWidth /> Duplicate
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" type="button" onClick={(e) => {
                                            canvas.getActiveObject().bringForward();
                                            videoPlaceholder.bringToFront();
                                        }}>
                                            <FontAwesomeIcon icon={faAngleUp} fixedWidth /> Bring forward
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" type="button" onClick={(e) => {
                                            canvas.getActiveObject().bringToFront();
                                            videoPlaceholder.bringToFront();
                                        }}>
                                            <FontAwesomeIcon icon={faAngleDoubleUp} fixedWidth /> Bring to front
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" type="button" onClick={(e) => {
                                            canvas.getActiveObject().sendBackwards();
                                        }}>
                                            <FontAwesomeIcon icon={faAngleDown} fixedWidth /> Send backwards
                                        </button>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" type="button" id="btnChangeImage" onClick={(e) => {
                                            canvas.getActiveObject().sendToBack();
                                        }}>
                                            <FontAwesomeIcon icon={faAngleDoubleDown} fixedWidth /> Send to back
                                        </button>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button className="dropdown-item" type="button" id="btnDeleteObject" onClick={(e) => {
                                            if (selectedObject?.isEditing) {
                                                selectedObject.exitEditing();
                                            }
                                            removeObjectFromCanvas();
                                        }}>
                                            <FontAwesomeIcon icon={faTrashAlt} fixedWidth className="text-danger" /> Delete <span className="float-end small"><kbd>[Del]</kbd></span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            {isLoading &&
                                <div className="position-absolute bg-white w-100 h-100 d-flex justify-content-center align-items-center">
                                    <div className="spinner-grow" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                </Col>
            </Row>
            <div className="d-flex justify-content-end align-items-center mt-3">
                {uploadPercentage > -1 ?
                    <div style={{ width: '200px' }}>
                        <ProgressBar
                            now={uploadPercentage}
                            label={`${uploadPercentage}%`}
                            style={{ height: '20px' }}
                        />
                    </div>
                    :
                    <Button size="lg" variant="secondary" className="px-5" onClick={saveFrame}>
                        {event?.frameConfigured ?
                            <>Save</>
                            :
                            <>
                                Next <FontAwesomeIcon icon={faArrowAltCircleRight} fixedWidth></FontAwesomeIcon>
                            </>
                        }
                    </Button>
                }
            </div>
        </div>
    );
}

export default FrameBuilder
